// src/stores/UIStore.js
import { makeObservable, observable, action } from "mobx";

export default class UIStore {
  currentPage = '';
  viewSize = 0;
  screenWidth = window.innerWidth;
  screenHeight = window.innerHeight;
  isLoading = false;
  screenMobile = (window.innerWidth < 700);

  // 🔥 Add notification state
  notification = {
    open: false,
    message: '',
    severity: 'info', // "success" | "error" | "warning" | "info"
    duration: 6000
  };

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeObservable(this, {
      currentPage: observable,
      viewSize: observable,
      screenWidth: observable,
      screenHeight: observable,
      isLoading: observable,
      screenMobile: observable,
      notification: observable,   // track notification
      setLoading: action,
      setScreenWidth: action,
      setScreenHeight: action,
      showNotification: action,
      hideNotification: action
    });
  }

  setLoading(val) {
    this.isLoading = val;
  }

  setScreenWidth(width) {
    this.screenWidth = width;
  }

  setScreenHeight(height) {
    this.screenHeight = height;
  }

  showNotification(message, severity = "info", duration = 4000) {
    this.notification = {
      open: true,
      message,
      severity,
      duration
    };
  }

  hideNotification() {
    this.notification.open = false;
  }
}
